module.exports = __webpack_public_path__ + "src/assets/2015/29.jpg";